import React, { useMemo, useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import { createTheme, responsiveFontSizes, ThemeProvider } from "@mui/material/styles";
import { AppBar, Avatar, Box, IconButton, Popover, Stack, Toolbar, Typography } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ContainerDrawer } from "./basic/container-drawer";
import { AppSingleton, difficulties } from "./services/user_config";
import { resizeListener } from "./utils/CommonUtils";

const App = () => {
  var appSingleton = new AppSingleton();
  const [fontScale, setFontScale] = useState(1.0);
  const [isDarkMode, setIsDarkModel] = useState(true);
  const [mirrorFPS, setMirrorFPS] = useState(15);
  const [mirrorDifficulty, setMirrorDifficulty] = useState(difficulties[0]);
  const [isEffect, setIsEffect] = useState(false);

  appSingleton.fontScale = fontScale;
  appSingleton.setFontScale = setFontScale;
  appSingleton.isDarkMode = isDarkMode;
  appSingleton.setIsDarkModel = setIsDarkModel;
  appSingleton.mirrorFPS = mirrorFPS;
  appSingleton.setMirrorFPS = setMirrorFPS;
  appSingleton.mirrorDifficulty = mirrorDifficulty;
  appSingleton.setMirrorDifficulty = setMirrorDifficulty;
  appSingleton.isEffect = isEffect;
  appSingleton.setIsEffect = setIsEffect;

  // var theme = createTheme({
  //   palette: {
  //     mode: "dark",
  //     primary: {
  //       main: "#ffffff",
  //     },
  //   },
  // });;
  var theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: isDarkMode ? "dark" : "light",
          primary: {
            main: isDarkMode ? "#ffffff" : "#000000",
          },
          card: {
            main: isDarkMode ? "#121212" : "#bbbbbb",
          },
          chip: {
            main: isDarkMode ? "#333333" : "#cccccc",
          },
          background: {
            main: isDarkMode ? "#000000" : "#ffffff",
          }
        },
      }),
    [isDarkMode]
  );
  theme = responsiveFontSizes(theme);

  // const [windowSize, setWindowSize] = useState({
  //   width: window.innerWidth,
  //   height: window.innerHeight,
  // });
  // appSingleton.windowSize = windowSize;
  resizeListener();

  useEffect(() => {
    window.addEventListener("resize", resizeListener);
    return () => {
      window.removeEventListener("resize", resizeListener);
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          backgroundColor: theme.palette.background.default,
          // height: "100vh",
        }}
      >
        <BrowserRouter basename={process.env.PUBLIC_URL}>
          <ContainerDrawer />
        </BrowserRouter>
        <ToastContainer />
      </Box>
    </ThemeProvider>
  );
};
export default App;
